module.exports = __webpack_public_path__ + "static/media/tavanaLogo.47a15dd8.png";